<app-document-subheader />
<app-custom-actions-flow-insurance-claim/>

@let insuranceClaim = this.insuranceClaim$ | async;

<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (insuranceClaim) {
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">

                <div class="row mb-2">
                  <div class="col-12 col-md-9 mr-auto">
                    <div class="form-group">
                      <label class="form-title-label" translate
                      >INSURANCE_CLAIM_LBL_NAME</label
                      >
                      <div class="form-title">{{ insuranceClaim.name }}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-md">

                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >INSURANCE_CLAIM_LBL_CONTRACT</label
                      >
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          <app-link-to
                            [id]="insuranceClaim.contractUniqueId"
                            [label]="insuranceClaim.contractName"
                            [url]="'/Insurance/Contracts/Details/'"
                          />
                          </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >INSURANCE_CLAIM_LBL_TYPE</label
                      >
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm h-100">
                          <app-link-to
                            [id]="insuranceClaim.claimTypeId.toString()"
                            [label]="insuranceClaim.claimTypeName"
                            [url]="'/Insurance/ClaimTypes/Details/'"
                          />
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >INSURANCE_CLAIM_LBL_OCCURRENCE_DATE</label
                      >
                      <div class="col">
                        <span
                          class="form-control-plaintext form-control-sm">
                          {{
                            insuranceClaim.occurrenceDate ?
                              (insuranceClaim.occurrenceDate | date : "dd/MM/yyyy")
                              : '-'
                          }}
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >INSURANCE_CLAIM_LBL_LIABILITY_RATE</label
                      >
                      <div class="col">
                        <span
                          class="form-control-plaintext form-control-sm">
                          @if (insuranceClaim.liabilityRate == null) {
                            -
                          } @else {
                            {{ insuranceClaim.liabilityRate | showSignValueType: 'Percentage' }}
                          }
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >INSURANCE_CLAIM_LBL_SALESPERSON</label
                      >
                      <div class="col">
                        <span
                          class="form-control-plaintext form-control-sm">
                          {{
                            insuranceClaim.salesPersonContactName
                          }}
                        </span>
                      </div>
                    </div>


                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >INSURANCE_CLAIM_LBL_DESCRIPTION</label
                      >
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm h-100">
                          {{ insuranceClaim.description }}
                        </span>
                      </div>
                    </div>

                  </div>
                  <div class="col">

                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >INSURANCE_CLAIM_LBL_CONTACT</label
                      >
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          <app-link-to
                            [id]="insuranceClaim.contactId.toString()"
                            [label]="insuranceClaim.contactName"
                            [url]="'/Contacts/Contacts/Details/'"
                          />
                          </span>
                      </div>
                    </div>

                    <!--                    <div class="form-group row invisible">-->
                    <!--                      <label class="col-4 col-form-label-sm" translate-->
                    <!--                      ></label-->
                    <!--                      >-->
                    <!--                      <div class="col">-->
                    <!--                        <input-->
                    <!--                          class="form-control form-control-sm"-->
                    <!--                          type="text"-->
                    <!--                        />-->
                    <!--                      </div>-->
                    <!--                    </div>-->

                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate>INSURANCE_CLAIM_LBL_ESTIMATED_AMOUNT</label>
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          @if (insuranceClaim.estimatedAmount == null) {
                            -
                          } @else {
                            {{ insuranceClaim.estimatedAmount | showSignValueType: 'Monetary' }}
                          }
                        </span>
                      </div>
                    </div>


                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >INSURANCE_CLAIM_LBL_DECLARATION_DATE</label
                      >
                      <div class="col">
                        <span
                          class="form-control-plaintext form-control-sm">
                          {{
                            insuranceClaim.declarationDate ?
                              (insuranceClaim.declarationDate | date : "dd/MM/yyyy")
                              : '-'
                          }}
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate>INSURANCE_CLAIM_LBL_DEDUCTIBLE_AMOUNT</label>
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          @if (insuranceClaim.deductibleAmount == null) {
                            -
                          } @else {
                            {{ insuranceClaim.deductibleAmount | showSignValueType: 'Monetary' }}
                          }
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >INSURANCE_CLAIM_LBL_INTERNAL_ID</label
                      >
                      <div class="col">
                        <span
                          class="form-control-plaintext form-control-sm">
                          {{
                            insuranceClaim.internalId
                          }}
                        </span>
                      </div>
                    </div>

                  </div>
                </div>

                <app-insurance-claim-tabs-details
                  [insuranceClaim]="insuranceClaim"
                />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    @if (insuranceClaim) {
      <div class="col-comment">
        <app-comment-panel
          [entityType]="'InsuranceClaim'"
          [entityId]="insuranceClaim.id.toString()"
        ></app-comment-panel>
      </div>
    }
  </div>
</div>
